import axios, { AxiosRequestConfig, Method } from 'axios';

export const API = async (
  target = '',
  method = 'GET',
  body = {}, // Allow FormData or regular objects
  query = '',
  token = '', // Optional token for authentication
) => {
  try {
    const url = `${target}${query}`;

    const isFormData = body instanceof FormData; // Check if body is FormData

    const config = {
      method,
      url,
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }), // Let FormData handle its own headers
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      ...(method !== 'GET' && { data: body }), // Attach body only for non-GET methods
    };

    const response = await axios(config);
    if (response.status === 200 || response.status == 201) {
      return response.data;
    }

    throw new Error(`API request failed with status: ${response.status}`);
  } catch (error) {
    console.error('API Error:', error);
    return false;
  }
};
